const formatYesNo = (val = '') => {
  if (val?.toLowerCase() === 'y') {
    return 'YES';
  } else if (val?.toLowerCase() === 'n') {
    return 'NO';
  }
  return '';
};

export default formatYesNo;
